import axios from 'axios';
import router from '@/router';

export const state = {
  user: null,
  userApplicants: null,
};

export const mutations = {
  SET_USER_DATA(state, userData) {
    console.log(userData);
    state.user = userData;
    localStorage.setItem('user', JSON.stringify(userData));
    axios.defaults.headers.common['Authorization'] = `Bearer ${userData.jwt}`;
  },
  SET_VIDEO(state, videoId) {
    console.log(state);
    console.log(videoId);
    state.user.user.candidate.video = videoId;
    localStorage.setItem('user', JSON.stringify(state.user));
  },
  SET_USER_APPLICANTS(state, data) {
    state.userApplicants = data;
    state.user.user.applicants = data;
    localStorage.setItem('user', JSON.stringify(state.user));
  },
};

export const actions = {
  FETCH_USER_APPLICANTS({ commit }, { userId }) {
    console.log(userId);
    axios
      .get(`${process.env.VUE_APP_REST_HTTP}/applicants?user.id=${userId}`)
      .then((response) => {
        console.log(response);
        commit('SET_USER_APPLICANTS', response.data);
      });
  },

  SEND_FORGOTTEN_PASSWORD({ dispatch }, { email }) {
    console.log(email);
    axios
      .post(`${process.env.VUE_APP_REST_HTTP}/auth/forgot-password`, {
        email: email,
      })
      .then((response) => {
        console.log(response);
        console.log('Your user received an email');
        dispatch('HANDLE_SNACKBAR', {
          snackbar: true,
          snackbarText:
            'An email has been sent to your inbox. Please follow the instructions to change your password.',
        });
      })
      .catch((error) => {
        console.log('An error occurred:', error.response);
      });
  },

  HANDLE_RESET_PASSWORD({ commit }, { code, password, passwordConfirmation }) {
    console.log(commit);
    axios
      .post(`${process.env.VUE_APP_REST_HTTP}/auth/reset-password`, {
        code: code, // code contained in the reset link of step 3.
        password: password,
        passwordConfirmation: passwordConfirmation,
      })
      .then((response) => {
        console.log(response);
        // console.log("Your user's password has been reset.");
        // localStorage.removeItem('user');
        router.push('/');
      })
      .catch((error) => {
        console.log('An error occurred:', error.response);
      });
  },

  HANDLE_UPDATE_EMAIL({ commit, dispatch }, payload) {
    console.log(payload);
    console.log(commit);

    return axios
      .put(
        `${process.env.VUE_APP_REST_HTTP}/users/${payload.userId}` ||
          `http://localhost:1337/users/${payload.userId}`,
        {
          email: payload.email,
        }
      )
      .then(({ data, status }) => {
        if (status === 200) {
          console.log(data);
          console.log('email changed');
          dispatch('HANDLE_SNACKBAR', {
            snackbar: true,
            snackbarText:
              'Your email has been updated - Please login with your new credentials',
          });
          alert('Email updated - Please login with your new credentials');
          dispatch('LOGOUT');
          //commit('UPDATE_CANDIDATE');

          // localStorage.removeItem('user');
          // location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  UPDATE_VIDEO({ commit }, state, id) {
    console.log(state);
    console.log(id);
    commit('SET_VIDEO', state, id);
  },
  LOGIN({ commit }, credentials) {
    return axios
      .post(
        process.env.VUE_APP_REST_AUTH || 'http://localhost:1337/auth/local',
        credentials
      )
      .then(({ data, status }) => {
        if (status === 200) {
          commit('SET_USER_DATA', data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  REGISTER({ commit }, credentials) {
    return axios
      .post(
        process.env.VUE_APP_REST_AUTH
          ? `${process.env.VUE_APP_REST_AUTH}/register`
          : 'http://localhost:1337/auth/local/register',
        credentials
      )
      .then(({ data, status }) => {
        console.log(data);
        if (status === 201) {
          commit('SET_USER_DATA', data);
          //alert('ACCOUNT CREATED');
        }
        // create candidate
      })
      .catch((error) => {
        console.log(error);
      });
  },

  CLEAR_USER_DATA(state) {
    state.user = null;
    localStorage.removeItem('user');
    axios.defaults.headers.common['Authorization'] = null;
  },
  LOGOUT() {
    localStorage.removeItem('user');
    location.reload();
  },
};

export const getters = {
  loggedIn(state) {
    console.log(state);
    return !!state.user;
  },
  getUserApplicants(state) {
    return state.userApplicants;
  },
  getUserData(state) {
    return state.user.user;
  },
  getJwtToken(state) {
    return state.user.jwt;
  },
  getUserId(state) {
    return state.user.user.id;
  },
  getEmail(state) {
    return state.user.user.email;
  },
  getUserVideo(state) {
    return state.user.user.candidate.video;
  },
  getUserType(state) {
    return state.user.user.type;
  },
  getUserVideoThumb(state) {
    return state.user.user.candidate.videoThumb;
  },
};
